import { Link } from 'react-router';
import { ArrowUpRight } from '@/icons';
import { Branding, DesignLayout, CodeLaptop } from '@/illustrations';
import { cn } from '@/lib/cn';

type Props = {
  title: string;
  tagline: string;
  href: string;
  illustration: 'branding' | 'designLayout' | 'codeLaptop';
  className?: string;
};

const illustrationMap = {
  branding: Branding,
  designLayout: DesignLayout,
  codeLaptop: CodeLaptop,
};

export function ServiceCard({ title, tagline, href, illustration, className }: Props) {
  const Illustration = illustrationMap[illustration];
  return (
    <Link
      to={href}
      className={cn(
        'group relative flex flex-col justify-between bg-surface border border-border p-8 md:p-10 min-h-[380px]',
        'transition-all duration-300 hover:border-border-strong hover:bg-surface-raised',
        'focus-visible:outline-2 focus-visible:outline-accent focus-visible:outline-offset-4',
        className,
      )}
    >
      <div className="relative h-40 mb-6 text-ink-primary">
        <Illustration className="w-full h-full transition-transform duration-500 group-hover:-translate-y-1" />
      </div>
      <div className="flex flex-col gap-3">
        <h3 className="font-display text-3xl md:text-4xl font-medium tracking-tight">{title}</h3>
        <p className="text-ink-secondary text-base leading-relaxed">{tagline}</p>
        <span className="mono-meta text-accent inline-flex items-center gap-1 mt-2">
          Read more <ArrowUpRight className="w-3.5 h-3.5" />
        </span>
      </div>
    </Link>
  );
}
